// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__WSrzV","spin":"Spinner_spin__xlkyZ"};